import { Controller } from "@hotwired/stimulus"

// Simplified controller for Turbo-based load more
// Turbo handles the heavy lifting, we just need minimal state management
export default class extends Controller {
  connect() {
    console.log("Load more controller connected (Turbo-based)")
  }

  // Optional: Add any custom behavior before/after Turbo requests
  // Turbo handles everything automatically via data-turbo-method and turbo_stream responses
}